<div class="selection-type">
	<fieldset class="radio-group">
		<legend>Choose intersection type</legend>
		<input type="radio" class="radio-group-input" id="circle" value="circle" [(ngModel)]="intersectionType" checked>
		<label for="circle" class="radio-group-label">Circle</label>
		<input type="radio" class="radio-group-input" id="cross" value="cross" [(ngModel)]="intersectionType">
		<label for="cross" class="radio-group-label">Cross</label>
	</fieldset>
	<div class="help">
		<div>This feature requires road lines to load. There is some <b>delay</b>.</div>
		<ul class="help-items">
			<li>Zoom as far as possible. <b>Wait</b> for red/green lines to display</li>
			<li>Click intersection and <b>wait</b> for selection to appear</li>
		</ul>
	</div>
</div>
<form>
	<div class="setting" *ngIf="intersectionType === 'cross'">
		<label for="bufferDistance"> Buffer Distance: </label>
		<input placeholder="Buffer distance" name="bufferDistance" type="number" [(ngModel)]="crossBufferOptions.bufferDistance" />
	</div>
	<div class="setting" *ngIf="intersectionType === 'cross'">
		<label for="bufferDistanceUnit"> Buffer Distance Units: </label>
		<select id="bufferDistanceUnit" name="bufferDistanceUnit" [(ngModel)]="crossBufferOptions.bufferDistanceUnit">
			<option *ngFor="let option of bufferDistanceUnits;" [ngValue]="option.value">{{ option.name }}</option>
		</select>
	</div>
	<div class="setting">
		<label for="intersectionDistance"> Intersection Distance: </label>
		<input placeholder="Intersection distance" name="intersectionDistance" type="number" [(ngModel)]="crossBufferOptions.intersectionDistance" />
	</div>
	<div class="setting">
		<label for="intersectionDistanceUnit"> Intersection Distance Units: </label>
		<select id="intersectionDistanceUnit" name="intersectionDistanceUnit" [(ngModel)]="crossBufferOptions.intersectionDistanceUnit">
			<option *ngFor="let option of bufferDistanceUnits;" [ngValue]="option.value">{{ option.name }}</option>
		</select>
	</div>
</form>
